import { can } from "../../../shared/auth/access";
import { OperatorTerminalHeader as KioskHeader } from "../terminal/OperatorTerminalHeader";
import { TerminalState } from "../terminal/OperatorTerminalShell";
import { DowntimeReasonProposalWorkspace } from "../DowntimeReasonProposalReview";
import { shiftHours } from "../production-time";
import { MachineAssignmentPanel } from "./MachineAssignmentPanel";
import { useSystemAdministratorWorkspace } from "./useSystemAdministratorWorkspace";
import type { ProductionWorkspaceProps } from "../production-workspace-contract";

export function SystemAdministratorProductionBoard(props: ProductionWorkspaceProps) {
  const { reference, terminalAdmin, loading, assignmentOpen, setAssignmentOpen, shiftCode, refresh } = useSystemAdministratorWorkspace(props);
  return <div className="production-supervisor-shell">
    <KioskHeader label="Sistem Yönetimi · Üretim Operasyonları" hours={shiftHours(shiftCode)} user={props.user} onLogout={props.onLogout} />
    <main className="production-supervisor-board">
      {loading ? <TerminalState title="Atamalar yükleniyor" text="Makine, vardiya ve operatör bilgileri hazırlanıyor." /> : null}
      {!loading && terminalAdmin && reference ? <MachineAssignmentPanel user={props.user} data={terminalAdmin} reference={reference} shiftCode={shiftCode} refreshVersion={props.dataRefreshVersion} open={assignmentOpen} onOpenChange={setAssignmentOpen} onSaved={refresh} onLogout={props.onLogout} notify={props.notify} /> : null}
      {!loading && can(props.user, "production.run.manage") ? <DowntimeReasonProposalWorkspace /> : null}
    </main>
  </div>;
}
